<template>
  <div class="breadcrumbs">
    <router-link to="/">Home</router-link>
    <span v-if="current.meta.parent" class="seperator"></span>
    <router-link v-if="current.meta.parent" :to="current.meta.url">
      {{ current.meta.parent }}
    </router-link>
    <span class="seperator"></span>
    <span>{{ currentTitle }}</span>
  </div>
</template>

<script>

export default {
  name: 'Breadcrumbs',
  props: {
    current: Object
  },
  data() {
    return {
      currentTitle: ''
    };
  },
  watch: {
    current: {
      handler(newVal) {
        if(newVal.name === 'Page'){
          let title = newVal.path.replace(/\//g, ''); // Remove slashes
          title = title.replace(/-/g, ' '); // Remove dashes
          title = title.charAt(0).toUpperCase() + title.slice(1); // Capitalize first letter
          this.currentTitle = title;
        }else{
          this.currentTitle = newVal ? newVal.name : '';
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";

.breadcrumbs {
  display: flex;
  align-items: center;
  .seperator{
    height:2rem;
    width: 1rem;
    margin: 0 0.8rem;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'%3E%3C!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath d='M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z'/%3E%3C/svg%3E");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 0.7rem;
    opacity: 0.6;
  }
  a{
    color: $darkgrey;
  }
}

</style>
